
































































































import Vue from '@front-app/vendor/vue';
import {
	computed,
	defineComponent,
	nextTick,
	PropType,
	ref,
} from '@vue/composition-api';
import SimpleDropdown from '@front-app/components/dropdowns/SimpleDropdown.vue';
import DropdownDivider from '@front-app/components/dropdowns/DropdownDivider.vue';
import { DropdownPosition } from '@front-app/components/dropdowns/dropdownPosition';
import { ButtonPalettes } from '@front-app/components/buttons/palettes';
import { FOCUSABLE_ERROR_INPUT_CLASS } from '@front-app/components/form/form';
import ButtonList from '@front-app/components/dropdowns/ButtonList.vue';
import ChevronIcon from '@front-app/components/icons-old/ChevronDown.vue';
import FormInput from '@front-app/components/form/FormInput.vue';
import PublicLink from '@front-app/components/buttons/PublicLink.vue';
import CtaButton from '@front-app/components/buttons/CtaButton.vue';
import { SelectBoxChoice } from './SelectBoxModel';

let i = 0;
const uid = () => `select_box_${i++}`;

export default defineComponent({
	components: {
		SimpleDropdown,
		FormInput,
		ChevronIcon,
		PublicLink,
		DropdownDivider,
		CtaButton,
		ButtonList,
	},
	props: {
		choices: {
			type: Array as PropType<SelectBoxChoice[]>,
			required: true,
		},
		hiddenChoices: {
			type: Array as PropType<(string | number)[]>,
			default: () => [],
		},
		position: {
			type: Number as PropType<DropdownPosition>,
			default: DropdownPosition.BOTTOM_RIGHT,
		},
		focusItemKey: {
			type: [String, Number] as PropType<undefined | string | number>,
			default: null,
			required: false,
		},
		activatorButtonId: {
			type: String,
			required: false,
			default: '',
		},
		activatorButtonClass: {
			type: String,
			required: false,
			default: '',
		},
		searchable: Boolean,
		unsorted: Boolean,
		closeOnSelection: Boolean,
		isActive: Boolean,
		hasError: Boolean,
		isFullWidth: Boolean,
		isActivatorButtonReversed: Boolean,
		isActivatorButtonAlignStart: Boolean,
	},
	setup(props, ctx) {
		const theUid = uid();
		const inputField = ref(null as null | Vue);
		const filterText = ref('');
		const isMenuOpen = ref(false);
		const filteredChoices = computed(() => props.choices
			.filter(({ key }) => !props.hiddenChoices.includes(key))
			.filter(({ label }) => label.toLocaleLowerCase().includes(filterText.value.toLocaleLowerCase()))
			.sort((a, b) => (props.unsorted ? 0 : a.label.localeCompare(b.label))));
		return {
			uid: theUid,
			FOCUSABLE_ERROR_INPUT_CLASS,
			inputField,
			filterText,
			isMenuOpen,
			filteredChoices,
			ButtonPalettes,
			selectItem(choice: SelectBoxChoice) {
				ctx.emit('select', choice.key);
				isMenuOpen.value = props.closeOnSelection ? false : isMenuOpen.value;
			},
			toggleMenu: async () => {
				isMenuOpen.value = !isMenuOpen.value;
				if (!props.focusItemKey || !isMenuOpen.value) {
					return;
				}
				// 2 nextTicks because of Portal...
				await nextTick();
				await nextTick();
				const el = document.querySelector(`#${theUid} [data-key="${props.focusItemKey}"]`) as undefined | HTMLButtonElement;
				if (!el) {
					return;
				}
				el.focus();
				el.scrollTop = el.scrollHeight;
			},
		};
	},
});
